<template>
  <div class="minerve-base">
    <v-card
      flat
      tile
    >
      <v-card-actions class="justify-space-between">
        <v-btn
          text
          @click="prev"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-item-group
          v-model="onboarding"
          class="text-center"
          mandatory
        >
          <hr>
          <v-item
            v-for="n in steps"
            :key="`btn-${n}`"
            v-slot:default="{ active, toggle }"
          >
            <v-btn
              :input-value="active"
              icon
              @click="toggle"
            >
              {{ n }}
            </v-btn>
          </v-item>
        </v-item-group>
        <v-btn
          text
          @click="next"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
      <v-window
        v-model="onboarding"
        touchless
      >
        <v-container>
          <!-- Step one -->
          <v-window-item>
            <StepOne :form="minerva" />
          </v-window-item>

          <!-- Step Two -->
          <v-window-item>
            <StepTwo :form="minerva" />
          </v-window-item>

          <!-- Step Three -->
          <v-window-item>
            <StepThree :form="minerva" />
          </v-window-item>
        </v-container>
      </v-window>
      <div class="save-container">
        <v-btn
          class="cancel"
          @click="dialog = true"
        >
          <v-icon>mdi-close</v-icon>Annuler
        </v-btn>
        <v-btn
          class="save"
          @click="onSubmit"
        >
          <v-icon>mdi-content-save</v-icon>Enregistrer
        </v-btn>
      </div>
    </v-card>

    <!-- Confirmation dialog -->
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Annulation
        </v-card-title>
        <v-card-text>Toutes modifications seront perdues !</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn
            color="red"
            dark
            text
            @click="$router.go(-1)"
          >
            Oui
          </v-btn>
          <v-btn
            text
            color="black"
            @click="dialog = false"
          >
            Non
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import handleProducts from "@/mixins/handleProducts.js";

import StepOne from "./components/StepOne";
import StepTwo from "./components/StepTwo";
import StepThree from "./components/StepThree";

export default {
  name: "MinerveBase",
  components: {
    StepOne,
    StepTwo,
    StepThree
  },
  mixins: [handleProducts],
  provide() {
    return { parentValidator: this.$validator };
  },
  props: {
    projectUuid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // How many steps for this product
      steps: 3,
      onboarding: 0,
      dialog: false,

      minerva: JSON.parse(JSON.stringify(this.$store.state.minerva.minerva))
    };
  },
  destroyed() {
    this.$store.dispatch("minerva/resetProduct");
  },
  methods: {
    // Submit product
    async onSubmit() {
      // Check if form is valid
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        if (this.errors.items.length > 0) {
          this.errors.items.map(e => {
            const notif = {
              message: e.msg,
              type: "error"
            };
            this.$store.dispatch("notifications/add", notif);
          });
          return;
        }
      }

      // Form is valid ! Save product
      this.saveProduct(this.minerva, this.projectUuid, "NECK_BRACE");
    },

    // Next step
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },

    // Previous step
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    }
  }
};
</script>

<style lang="scss"></style>
